import React from 'react';

import CloseIcon from '@/components/Icon/CloseIcon';

import * as S from './style';

interface IProps {
	fileName: string;
	fileSize: string;
	removeAction?: () => void;
	willBeDeletedItem: boolean;
}

const FileItem = ({ fileName, fileSize, removeAction, willBeDeletedItem }: IProps) => (
	<>
		<S.FileList>
			<S.FileListUl>
				<S.FileItem deleted={willBeDeletedItem}>
					<S.FileContent>
						<div className="title">{fileName ?? ''}</div>
						<div className="sub_title">{fileSize}</div>
					</S.FileContent>
					{removeAction && (
						<div
							onClick={(e: any) => {
								e.stopPropagation();
								removeAction();
							}}
						>
							<CloseIcon iconColor="#ADB5BD" width="20" height="20" />
						</div>
					)}
				</S.FileItem>
			</S.FileListUl>
		</S.FileList>
	</>
);

export default FileItem;
